import Vue from 'vue';

const success = (context, data) => {
  context.isLoading = false;

  if (data.msg === 'requires_source_action') {
    context.paymentIntent = data.intent;
    context.bookingDetail = data.bookingData;
    $('#secure-iframe').attr('src', context.paymentIntent.next_action.redirect_to_url.url);
    $('#secure-iframe').css('display', 'block');
    context.showSecureIframe = true;
  } else {
    context.isCreatedBooking = true;
    context.loading = false;
  }
};

const failed = (context, error) => {
  context.isLoading = false;
  context.loading = false;
  context.bookingDetail.promo_type = null;
  context.bookingDetail.promo_amount = null;
  context.bookingDetail.promo_id = null;
  context.showToasterError(error);
};

export default (context, data) => Vue.$http.post('retry-reservation-payment', data)
  .then((response) => {
    if (response && response.status === 200) {
      success(context, response.data);
    }
  }).catch((error) => {
    if (error) {
      failed(context, error);
    }
  }).finally(() => {
  })



// WEBPACK FOOTER //
// ./src/app/services/booking/retryWebsiteReservationPayment.js